import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { CategoryFilter, ClassFilter, Container, Input, ParkingFilter, Select, ButtonsContainer, DoubleField, DateSelect, DateTime, DictFilter } from 'libs/form';

const initial = {};

const Filter = (props) => {
  const { className, setInitial, reset, handleSubmit, change, theme, clientId } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  const cl = `${className} cp-filter`;

  return (
    <Container theme={theme} className={cl}>
      <form onSubmit={handleSubmit}>
        <Input width="170px" name="mean_id" type="text" label={t('sections.БСК')} placeholder="3786 4678 6467 5656" />

        <Input width="130px" name="vehicle_plate" type="text" label={t('sections.ГРЗ')} placeholder={t('form.А000AA 000 rus')} />

        <DictFilter name="is_blocked" dict="payment_mean.status" />

        <DateSelect from_name="start_at_from" to_name="start_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="start_at_from" type="dateTime" label={t('form.Дата действия с')} theme={theme} />
            <DateTime width="160px" name="start_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <DateSelect from_name="end_at_from" to_name="end_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="end_at_from" type="dateTime" label={t('form.Дата действия по')} theme={theme} />
            <DateTime width="160px" name="end_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <Input width="220px" name="owner" type="text" label={t('form.Держатель')} placeholder={t('form.Введите текст для поиска')} />

        {!clientId && <Input label={t('form.Клиент')} width="230px" name="client_name" type="text" placeholder={t('form.Название клиента')} />}

        <ClassFilter multiple />

        <CategoryFilter multiple />

        <Select width="120px" name="is_privileged" type="select" label={t('form.Свободный проезд')} theme={theme}>
          <option value="">{t('filter.Все')}</option>
          <option value={true}>{t('grid.Да')}</option>
          <option value={false}>{t('grid.Нет')}</option>
        </Select>

        <Input label={t('filter.Комментарий')} width="230px" name="comment" type="text" placeholder={t('filter.Текст комментария')} />

        <ParkingFilter theme={theme} ml0 />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'cscFilter',
  destroyOnUnmount: false,
  initialValues: initial,
})(Filter);
